import { Outlet } from 'react-router-dom';
import SuperAdminSidebar from '@/components/super-admin/SuperAdminSidebar';

function SuperAdminContent() {
  return (
    <div className="flex w-full">
      {/* sidebar */}
      <SuperAdminSidebar />
      <main className="relative w-full h-full min-h-screen pt-0 overflow-hidden transition-all ease-in text-dark-text">
        <div className="flex flex-col w-full transition-all ease-in h-full pl-[250px]">
          {/* content */}
          <div className="p-6 mt-6">
            <Outlet />
          </div>
        </div>
      </main>
    </div>
  );
}

export default SuperAdminContent;
